const KEY = "vernias-portal-theme";
export type Theme = "dark" | "light";

export function getTheme(): Theme {
  return (localStorage.getItem(KEY) as Theme) ?? "dark";
}

export function applyTheme(theme: Theme = getTheme()): void {
  document.body.classList.toggle("light-theme", theme === "light");
  localStorage.setItem(KEY, theme);
}

export function toggleTheme(): Theme {
  const next: Theme = getTheme() === "dark" ? "light" : "dark";
  applyTheme(next);
  return next;
}
